import { useEffect } from "react";
import toast, { Toaster, useToasterStore } from "react-hot-toast";

const TOAST_LIMIT = 1;

const ToastContainer = () => {
  const { toasts } = useToasterStore();
  useEffect(() => {
    // prevent toasts from stacking up
    toasts
      .filter((t) => t.visible)
      .filter((_, i) => i >= TOAST_LIMIT)
      .forEach((t) => toast.remove(t.id));
  }, [toasts]);

  return (
    <Toaster
      toastOptions={{
        position: "bottom-center",
        style: { zIndex: 1000, background: "#000", color: "#fff" },
        className: "font-mono uppercase text-xs",
      }}
    />
  );
};

export default ToastContainer;
